import { useRef, useState } from "react";
import * as S from "./PatientForm.style"
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { Formik } from "formik";
import FlorenzInput from "../../../../../../../florenzComponents/florenzInput";
import FlorenzFieldForm from "../../../../../../../florenzComponents/florenzFieldForm";
import ZaiaSelectForm  from "../../../../../../../zaiaComponents/zaiaSelectForm";
import { useLazyQuery, useQuery } from "@apollo/client";
import { QUERY_GET_DOCUMENT_TYPES } from "../../../../../../../../graphql/queries/DocumentType";
import FlorenzButton from "../../../../../../../florenzComponents/florenzButton";
import ZaiaModalResponseContent from "../../../../../../../zaiaComponents/zaiaModalResponseContent";
import { QUERY_GET_SIGN_INFORMED_CONSENT_BY_DOCUMENT } from "../../../../../../../../graphql/queries/SigninformedConsent";

function PatientForm({
  setPatientVerified,
  temporalPatientInfo,
  setTemporalPatientInfo,
  setPatientData,
  patientId,
  setPatientId
}) {

  const { t, i18n: { language } }= useTranslation("global");
  const [newPatient, setNewPatient] = useState(temporalPatientInfo ? true : false);
  const { data: documentTypeData } = useQuery(QUERY_GET_DOCUMENT_TYPES);
  const [ getSignInformedConsent, {data: informedConsent, loading: informedConsentLoading, error: informedConsentError}] = useLazyQuery(
    QUERY_GET_SIGN_INFORMED_CONSENT_BY_DOCUMENT,
    {
      fetchPolicy: "network-only"
    }  
  );
  const [successVerification, setSuccessVerification] = useState(null);

  const [patientAddedBefore, setPatientAddedBefore] = useState(false); 
  

  const handleVerifyPatient = async () => {
    const result = await searchPatient();
    if(result) {
      setPatientAddedBefore({
        name: result.name,
        document: result.documentNumber,
        phone: result.phone,
        typeDocument: result.documentType,
      })
      setSuccessVerification(true);
    } else {
      setNewPatient(true);
    }
  };

  const handleSubmit = async (values) => {
    
    if(values?.document === patientId) {
      setTemporalPatientInfo(values);
      setPatientVerified(true);
    } else {
      const result = await searchPatient(values?.document);

      if(result) {
        setPatientAddedBefore({
          name: result.name,
          document: result.documentNumber,
          phone: result.phone,
          typeDocument: result.documentType
        })
        setSuccessVerification(true);
      } else {
        setTemporalPatientInfo(values);
        setPatientVerified(true);
      }
    }
  };
  
  const patientVerification = () => {
    setPatientData(patientAddedBefore);
  }

  const searchPatient = async (formPatientId) => {
    try {
      const {
        data: {
          signInformedConsent
        },
      } = await getSignInformedConsent({
        variables: {
          documentNumber: formPatientId || patientId
        }
      })            

      if(signInformedConsent?.length > 0) {
        return signInformedConsent[0];
      } else {
        return false;
      }
    } catch (error) {
      setSuccessVerification(false);
      console.log(error);
    }
  }

  if(successVerification !== null) {
    return (
      <ZaiaModalResponseContent
        button1={() => patientVerification()}
        // button2={() => setActiveConfirmModal(false)}
        formSuccess={successVerification}
        button1Text={successVerification ? t("followUp.confirm") : t("globally.tryAgain")}
        title={successVerification ? t("chatbotAI.imageReading.patientVerifiedSuccess") : t("chatbotAI.imageReading.patientVerifiedError")}
        subtitle={successVerification ? t("chatbotAI.imageReading.patientVerifiedSuccessSubtitle") : ""}
      />
    )
  }

  return (
    <S.PatientForm>
      <div className="header">
        <div className="header__left">
          <div className="title">
            {
              t("chatbotAI.imageReading.imagesAnalysis")
            }
          </div>
          <div className="subtitle">
            {
              newPatient 
                ? t("chatbotAI.imageReading.newPatient") 
                : t("chatbotAI.imageReading.patientVerification")
            }
          </div>
        </div>
        <div className="header__right">
          <div className="icon">
            <i className="zaia-icono-gallery"></i>
          </div>
        </div>
      </div>
      {
        !newPatient &&
        <form className="id-verification"
          onSubmit={(e) => {
            e.preventDefault();
            handleVerifyPatient();
          }}
        >
          <div className="inputs">
            <FlorenzFieldForm
              label={t("register.numberId")}
              value={patientId}
              required
              getText={(value) => setPatientId(value)}
            />
          </div>
          <div className="buttons">
            <div className="continue-button">
              <FlorenzButton
                type="submit"
                typeStyle={"primary"}
                size="s"
                text={t("globally.continue")}
                disabled={!patientId}
                icon={!patientId && "zaia-i-lock-chat"}
              />
            </div>
          </div>
        </form>
      }
      
      {
        newPatient &&
        <div className="form-new-patient">
          <Formik
            initialValues={{
              name: temporalPatientInfo?.name,
              document: temporalPatientInfo?.document || patientId,
              phone: temporalPatientInfo?.phone,
              typeDocument: temporalPatientInfo?.typeDocument,
            }}
            validationSchema={
              Yup.object().shape(
                {
                  name: Yup.string()
                    .required(t("register.validation.required")),
                  typeDocument: Yup.string()
                    .required(t("register.validation.required")),
                  document: Yup.string()
                    .required(t("register.validation.required")),
                  phone: Yup.number()
                    .positive(t("register.validation.invalid"))
                    .required(t("register.validation.required")),
                }
              )
            }
            onSubmit={handleSubmit}
          >
            {(props) => (
              <form 
                className="form"
                onSubmit={ props.handleSubmit }
              >
                <div className="inputs">
                  <div className="input">
                    <FlorenzFieldForm
                      label={t("register.typeOfId")}
                      value={props.values.typeDocument}
                      required
                      getText={(value) => props.setFieldValue("typeDocument", value)}
                      options={documentTypeData?.enDocumentType}
                    />
                  </div>
                  <div className="input">
                    <FlorenzFieldForm
                      label={t("register.numberId")}
                      value={props.values.document}
                      required
                      getText={(value) => props.setFieldValue("document", value)}
                    />
                  </div>
                  <div className="input">
                    <FlorenzFieldForm
                      label={t("globally.name")}
                      value={props.values.name}
                      required
                      getText={(value) => props.setFieldValue("name", value)}
                    />
                  </div>
                  <div className="input">
                    <FlorenzFieldForm
                      label={t("globally.phoneNumber")}
                      value={props.values.phone}
                      required
                      getText={(value) => props.setFieldValue("phone", value)}
                      {...props}
                    />
                  </div>
                </div>
                <div className="buttons">
                  <div className="cancel-button">
                    <FlorenzButton
                      type="button"
                      typeStyle={"secondaryWhite"}
                      size="s"
                      text={t("globally.cancel")}
                      onClick={() => {
                        setNewPatient(false);
                      }}
                    />
                  </div>
                  <div className="continue-button">
                    <FlorenzButton
                      typeStyle={"primary"}
                      size="s"
                      text={t("globally.next")}
                      disabled={!props.isValid}
                      icon={!props.isValid && "zaia-i-lock-chat"}
                      onClick={() => {
                        props.handleSubmit();
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      }
    </S.PatientForm>
  );

}

export default PatientForm;
